import { render, staticRenderFns } from "./MagicLinkRedirectModal.vue?vue&type=template&id=d60f7e8a&scoped=true"
import script from "./MagicLinkRedirectModal.vue?vue&type=script&lang=ts"
export * from "./MagicLinkRedirectModal.vue?vue&type=script&lang=ts"
import style0 from "./MagicLinkRedirectModal.vue?vue&type=style&index=0&id=d60f7e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60f7e8a",
  null
  
)

export default component.exports